<!-- Header with Restaurant Info -->
<div class="menu-header">
  <div class="header-actions">
    <button class="btn-back" (click)="goBack()">
      <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2">
        <polyline points="15 18 9 12 15 6"/>
      </svg>
    </button>
    
    <div class="restaurant-info" *ngIf="restaurantInfo()">
      <h1 class="restaurant-name">{{ restaurantInfo()?.name }}</h1>
      <p class="terminal-info" *ngIf="restaurantInfo()?.selectedTerminal">
        {{ restaurantInfo()?.selectedTerminal?.name }}
      </p>
    </div>

    <!-- PWA Install Button -->
    <button
      class="install-btn"
      *ngIf="shouldShowInstallButton()"
      (click)="handleInstallClick()"
      [title]="getInstallButtonTitle()">
      <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
        <polyline points="7 10 12 15 17 10"/>
        <line x1="12" y1="15" x2="12" y2="3"/>
      </svg>
    </button>

    <app-theme-toggle></app-theme-toggle>
  </div>

  <!-- Breadcrumbs -->
  <nav class="breadcrumbs" *ngIf="breadcrumbs().length > 0">
    <ol class="breadcrumb-list">
      <li *ngFor="let crumb of breadcrumbs(); let last = last" class="breadcrumb-item">
        <button 
          *ngIf="!last" 
          (click)="crumb.action()" 
          class="breadcrumb-link">
          {{ crumb.name }}
        </button>
        <span *ngIf="last" class="breadcrumb-current">{{ crumb.name }}</span>
        <span *ngIf="!last" class="breadcrumb-separator">›</span>
      </li>
    </ol>
  </nav>
</div>


<!-- Loading State -->
<div *ngIf="loading()" class="loading-container">
  <div class="spinner"></div>
  <p>Cargando menú...</p>
</div>

<!-- Error State -->
<div *ngIf="error()" class="error-container">
  <div class="error-message">
    <span class="error-icon">⚠️</span>
    <p>{{ error() }}</p>
    <button class="btn-retry" (click)="goBack()">Volver</button>
  </div>
</div>

<!-- Category Grid (shows when no category is selected) -->
<div *ngIf="!loading() && !error() && mainCategories().length > 0 && !selectedMainCategory()" class="categories-grid-view">
  <h2 class="categories-title">Elige una categoria</h2>
  <div class="categories-grid">
    <button
      *ngFor="let cat of mainCategories()"
      class="category-grid-card"
      (click)="selectMainCategory(cat)">
      <span class="category-card-icon">{{ cat.icon || '🍽️' }}</span>
      <span class="category-card-name">{{ cat.name }}</span>
      <span class="category-card-count">{{ cat.product_count || 0 }} productos</span>
    </button>
  </div>
</div>

<!-- Category Navigation — chips (visible when a category is selected) -->
<div *ngIf="!loading() && !error() && mainCategories().length > 0 && selectedMainCategory()" class="category-nav">
  <!-- Parent categories — horizontal scrollable chips -->
  <div class="parent-chips">
    <button
      *ngFor="let cat of mainCategories()"
      class="parent-chip"
      [class.active]="selectedMainCategory()?.id === cat.id"
      (click)="selectMainCategory(cat)">
      {{ cat.name }}
      <span class="chip-count">{{ cat.product_count || 0 }}</span>
    </button>
  </div>

  <!-- Subcategories — horizontal scrollable chips (if parent has subs) -->
  <div class="sub-chips" *ngIf="subCategories().length > 0">
    <button
      *ngFor="let sub of subCategories()"
      class="sub-chip"
      [class.active]="selectedSubCategory()?.id === sub.id"
      (click)="selectSubCategory(sub)">
      {{ sub.name }}
      <span class="chip-count">{{ sub.product_count || 0 }}</span>
    </button>
  </div>
</div>

<!-- Products View (shows when a category is selected, or all if no categories) -->
<!-- Packs / Menus del dia -->
<div class="packs-section" *ngIf="!loading() && !error() && packs().length > 0 && !selectedMainCategory()">
  <h2 class="packs-title">Menus y Packs</h2>
  <div class="packs-list">
    <button *ngFor="let pack of packs()" class="pack-card"
      [class.unavailable]="!isPackAvailable(pack)"
      [disabled]="!isPackAvailable(pack)"
      (click)="isPackAvailable(pack) && openPackModal(pack)">
      <div class="pack-info">
        <span class="pack-name">{{ pack.name }}</span>
        <span class="pack-desc" *ngIf="pack.description">{{ pack.description }}</span>
        <span class="pack-sections-count">{{ pack.sections?.length || 0 }} pasos</span>
        <span class="pack-availability" *ngIf="!isPackAvailable(pack)">{{ getPackAvailabilityText(pack) }}</span>
      </div>
      <span class="pack-price" *ngIf="pack.pack_price">{{ formatPrice(+(pack.pack_price)) }}</span>
    </button>
  </div>
</div>

<div *ngIf="!loading() && !error() && (selectedMainCategory() || mainCategories().length === 0)" class="products-view">
  <div class="products-header">
    <h2 class="section-title">
      <span *ngIf="selectedSubCategory()">{{ selectedSubCategory()?.name }}</span>
      <span *ngIf="!selectedSubCategory() && selectedMainCategory()">{{ selectedMainCategory()?.name }}</span>
      <span *ngIf="!selectedSubCategory() && !selectedMainCategory()">Todos los productos</span>
    </h2>

    <div class="products-header-right">
      <button class="view-toggle-btn" (click)="toggleProductView()" [title]="productViewMode() === 'grid' ? 'Vista lista' : 'Vista tarjetas'">
        @if (productViewMode() === 'grid') {
          <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/>
            <line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/>
          </svg>
        } @else {
          <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2">
            <rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/>
            <rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/>
          </svg>
        }
      </button>
      <div class="products-count">
        {{ availableProducts().length }} productos
      </div>
    </div>
  </div>
  
  <!-- Products Grid View -->
  <div class="products-grid" *ngIf="availableProducts().length > 0 && productViewMode() === 'grid'">
    <div
      *ngFor="let product of availableProducts()"
      class="product-card"
      [class.unavailable]="!product.available"
      (click)="product.available && openAddModal(product)">

      <div class="product-image" *ngIf="product.image_url">
        <img [src]="resolveImg(product.image_url)" [alt]="product.name" loading="lazy">
      </div>

      <div class="product-placeholder" *ngIf="!product.image_url">
        <span class="placeholder-name">{{ product.name }}</span>
      </div>

      <div class="product-info">
        <h3 class="product-name">{{ product.name }}</h3>

        <p class="product-description" *ngIf="product.description">
          {{ product.description }}
        </p>

        <div class="product-footer">
          <span class="product-price" *ngIf="product.price && !product.has_variants">
            {{ formatPrice(product.price) }}
          </span>
          <span class="product-price variant-price" *ngIf="product.has_variants && product.variants?.length">
            Desde {{ formatPrice(product.variants![0].price) }}
          </span>

          <span class="qty-badge" *ngIf="!product.has_variants && getProductQuantityInCart(product.id) > 0">
            {{ getProductQuantityInCart(product.id) }}
          </span>
        </div>
      </div>

      <div class="product-status" *ngIf="!product.available">
        <span class="status-unavailable">No disponible</span>
      </div>
    </div>
  </div>

  <!-- Products List View -->
  <div class="products-list" *ngIf="availableProducts().length > 0 && productViewMode() === 'list'">
    <div
      *ngFor="let product of availableProducts()"
      class="product-list-item-wrapper"
      [class.unavailable]="!product.available"
      [class.expanded]="product.has_variants && isVariantExpanded(product.id)">

      <!-- Main row — tap to open add-modal (normal) or expand (variants) -->
      <div class="product-list-item" (click)="onProductTap(product)">
        <div class="list-item-left">
          <div class="list-item-thumb" *ngIf="product.image_url">
            <img [src]="resolveImg(product.image_url)" [alt]="product.name" loading="lazy">
          </div>
          <div class="list-item-initial" *ngIf="!product.image_url">
            {{ product.name[0] }}
          </div>

          <div class="list-item-info">
            <h3 class="list-item-name">{{ product.name }}</h3>
            <p class="list-item-desc" *ngIf="product.description">{{ product.description }}</p>
            <span class="list-item-price" *ngIf="product.price && !product.has_variants">{{ formatPrice(product.price) }}</span>
            <span class="list-item-price variant-price" *ngIf="product.has_variants && product.variants?.length">Desde {{ formatPrice(product.variants![0].price) }}</span>
            <span class="list-item-allergens" *ngIf="product.allergens?.length">{{ product.allergens!.join(' · ') }}</span>
          </div>
        </div>

        <div class="list-item-right">
          <!-- Quantity badge (normal products) -->
          <span class="qty-badge" *ngIf="!product.has_variants && getProductQuantityInCart(product.id) > 0">
            {{ getProductQuantityInCart(product.id) }}
          </span>
          <!-- Expand arrow (variant products) -->
          <span class="variant-expand-arrow" *ngIf="product.has_variants" [class.open]="isVariantExpanded(product.id)">&#9660;</span>
        </div>
      </div>

      <!-- Variant options (expanded inline) -->
      <div class="variant-inline" *ngIf="product.has_variants && isVariantExpanded(product.id)">
        <div *ngFor="let variant of product.variants" class="variant-row"
             (click)="openAddModalVariant(product, variant)">
          <span class="variant-row-name">{{ variant.name }}</span>
          <div class="variant-row-right">
            <span class="variant-row-price">{{ formatPrice(variant.price) }}</span>
            <span class="variant-row-qty" *ngIf="getVariantQuantityInCart(product.id, variant.id) > 0">
              {{ getVariantQuantityInCart(product.id, variant.id) }}
            </span>
          </div>
        </div>
      </div>

      <div class="product-status" *ngIf="!product.available">
        <span class="status-unavailable">No disponible</span>
      </div>
    </div>
  </div>
  
  <!-- Empty State -->
  <div *ngIf="availableProducts().length === 0" class="empty-products">
    <div class="empty-icon">📦</div>
    <h3>No hay productos disponibles</h3>
    <p>En esta categoría no hay productos disponibles en este momento.</p>
    <button class="btn-back-categories" (click)="goBackToCategories()">
      Ver todas las categorías
    </button>
  </div>
</div>


<!-- Cart Display Component -->
<app-cart-display></app-cart-display>

<!-- Snake Game Component -->
<app-snake-game #snakeGame></app-snake-game>

<!-- Notes Modal -->
<div class="notes-modal-overlay" 
     [class.show]="showNotesModal()"
     (click)="closeNotesModal()">
</div>

<div class="notes-modal" 
     [class.show]="showNotesModal()">
  
  @if (selectedProduct(); as product) {
    <div class="modal-content">
      <div class="modal-header">
        <h4>📝 Nota para {{ product.name }}</h4>
        <button class="close-btn" (click)="closeNotesModal()">✕</button>
      </div>
      
      <div class="modal-body">
        <div class="form-group">
          <label for="product-notes">Escribe tu nota personalizada:</label>
          <textarea 
            id="product-notes"
            [(ngModel)]="tempNotesText"
            placeholder="Ejemplo: sin lechuga, extra queso, punto medio..."
            class="notes-textarea"
            rows="4">
          </textarea>
          <small class="help-text">
            Especifica ingredientes a quitar, agregar o cualquier preferencia especial
          </small>
        </div>
      </div>
      
      <div class="modal-footer">
        <button class="action-btn secondary" (click)="closeNotesModal()">
          Cancelar
        </button>
        <button 
          class="action-btn primary" 
          (click)="addProductWithNotes()"
          [disabled]="!tempNotesText.trim()"
          [class.has-text]="tempNotesText.trim()">
          Agregar al Carrito
        </button>
      </div>
    </div>
  }


</div>

<!-- Quick Add Modal (centered) -->
@if (addModalProduct) {
  <div class="add-modal-overlay" (click)="closeAddModal()"></div>
  <div class="add-modal" [class.has-customizations]="hasCustomizations">
    <button class="add-modal-close" (click)="closeAddModal()">&times;</button>

    <!-- Product name + allergens -->
    <div class="add-modal-name">{{ addModalProduct.name }}</div>
    <div class="add-modal-allergens" *ngIf="addModalProduct.allergens?.length">
      <span class="allergen-tag" *ngFor="let a of addModalProduct.allergens">{{ a }}</span>
    </div>
    <div class="add-modal-price" *ngIf="!addModalProduct.has_variants && addModalProduct.price">{{ formatPrice(addModalProduct.price) }}</div>

    <!-- Variant selection -->
    @if (addModalProduct.has_variants && !addModalVariant) {
      <div class="add-modal-section">
        <span class="section-label">Tamano</span>
        <div class="add-modal-variants">
          @for (variant of addModalProduct.variants; track variant.id) {
            <button class="add-modal-variant-btn" (click)="selectModalVariant(variant)">
              <span>{{ variant.name }}</span>
              <span class="variant-row-price">{{ formatPrice(variant.price) }}</span>
            </button>
          }
        </div>
      </div>
    }

    <!-- Selected variant -->
    @if (addModalVariant) {
      <div class="add-modal-selected-variant">
        <span>{{ addModalVariant.name }} — {{ formatPrice(addModalVariant.price) }}</span>
        <button class="change-variant-btn" (click)="addModalVariant = null">Cambiar</button>
      </div>
    }

    <!-- Customization (only after variant selected or if no variants) -->
    @if (!addModalProduct.has_variants || addModalVariant) {

      <!-- Optional ingredients (remove) -->
      <div class="add-modal-section" *ngIf="addModalProduct.ingredients_optional?.length">
        <span class="section-label">Quitar ingredientes</span>
        <div class="ingredient-chips">
          <button *ngFor="let ing of addModalProduct.ingredients_optional"
            class="ingredient-chip remove"
            [class.active]="addModalRemovedIngredients.has(ing.id)"
            (click)="toggleRemoveIngredient(ing.id)">
            <span class="chip-x" *ngIf="addModalRemovedIngredients.has(ing.id)">✕</span>
            {{ ing.name }}
          </button>
        </div>
      </div>

      <!-- Extras (add with price) -->
      <div class="add-modal-section" *ngIf="addModalProduct.ingredients_extras?.length">
        <span class="section-label">Extras</span>
        <div class="ingredient-chips">
          <button *ngFor="let extra of addModalProduct.ingredients_extras"
            class="ingredient-chip extra"
            [class.active]="addModalSelectedExtras.has(extra.id)"
            (click)="toggleExtra(extra.id)">
            <span class="chip-check" *ngIf="addModalSelectedExtras.has(extra.id)">✓</span>
            {{ extra.name }}
            <span class="chip-price" *ngIf="extra.extra_price">+{{ extra.extra_price }}€</span>
          </button>
        </div>
      </div>

      <!-- Note toggle -->
      <div class="add-modal-note" *ngIf="addModalShowNote">
        <input type="text" [(ngModel)]="addModalNote" placeholder="Sin hielo, poco hecho..." class="add-note-input" maxlength="100" (keyup.enter)="confirmAddModal()" />
      </div>

      <!-- Actions -->
      <div class="add-modal-actions">
        <button class="add-modal-btn-note" (click)="addModalShowNote = !addModalShowNote">
          {{ addModalShowNote ? 'Ocultar' : 'Nota' }}
        </button>
        <button class="add-modal-btn-add" (click)="confirmAddModal()">
          Anadir {{ formatPrice(modalTotalPrice) }}
        </button>
      </div>
    }
  </div>
}

<!-- Pack Wizard Modal -->
@if (packModalOpen && activePack) {
  <div class="add-modal-overlay" (click)="closePackModal()"></div>
  <div class="add-modal pack-modal">
    <button class="add-modal-close" (click)="closePackModal()">&times;</button>
    <div class="add-modal-name">{{ activePack.name }}</div>
    <div class="add-modal-price">{{ formatPrice(packTotalPrice) }}</div>
    <div class="pack-progress" *ngIf="!isPackSummaryStep">
      <div class="pack-progress-bar" [style.width.%]="((packSectionIndex) / activePack.sections.length) * 100"></div>
    </div>

    <!-- Section selector (not summary, not customizing) -->
    @if (!isPackSummaryStep && !packTempItem && currentPackSection) {
      <div class="pack-step-indicator">
        <span class="pack-step-label">{{ currentPackSection.name }}</span>
        <div class="pack-step-right">
          <span class="pack-optional-badge" *ngIf="isCurrentSectionOptional">Opcional</span>
          <span class="pack-step-count">{{ packSectionIndex + 1 }}/{{ activePack.sections.length }}</span>
        </div>
      </div>
      <div class="pack-section-hint">{{ sectionHint }}</div>

      <div class="pack-items-list">
        @for (item of currentPackSection.items; track item.product_id) {
          <button class="pack-item-btn"
            [class.selected]="packCurrentSelected.has(item.product_id)"
            [disabled]="!packCurrentSelected.has(item.product_id) && isMaxSelected"
            (click)="togglePackSectionItem(item)">
            <span class="pack-item-check">
              @if (currentPackSection.max_choices === 1) {
                <span class="radio-dot" [class.active]="packCurrentSelected.has(item.product_id)"></span>
              } @else {
                <span class="check-box" [class.active]="packCurrentSelected.has(item.product_id)">
                  @if (packCurrentSelected.has(item.product_id)) { <span class="check-mark">✓</span> }
                </span>
              }
            </span>
            <span class="pack-item-name">{{ item.product_name }}</span>
            <span class="pack-item-supplement" *ngIf="item.supplement_price">+{{ formatPrice(+(item.supplement_price || 0)) }}</span>
          </button>
        }
      </div>

      <div class="pack-nav-btns">
        <button class="add-modal-btn-note" *ngIf="packSectionIndex > 0" (click)="packGoBack()">Atras</button>
        <button class="add-modal-btn-note pack-skip-btn" *ngIf="isCurrentSectionOptional" (click)="skipPackSection()">Saltar</button>
        <button class="add-modal-btn-add pack-next-btn" [disabled]="!canAdvanceSection" (click)="advancePackSection()">
          Siguiente
          @if (currentPackSection.max_choices > 1) {
            <span class="next-count">({{ packCurrentSelected.size }}/{{ currentPackSection.max_choices }})</span>
          }
        </button>
      </div>
    }

    <!-- Item customization within pack -->
    @if (packTempItem) {
      <div class="pack-customizing">
        <span class="pack-customizing-name">{{ packTempItem.product_name }}</span>

        <!-- Optional ingredients -->
        @if (findProductById(packTempItem.product_id)?.ingredients_optional?.length) {
          <div class="add-modal-section">
            <span class="section-label">Quitar</span>
            <div class="ingredient-chips">
              @for (ing of findProductById(packTempItem.product_id)!.ingredients_optional!; track ing.id) {
                <button class="ingredient-chip remove" [class.active]="packTempRemoved.has(ing.id)" (click)="togglePackRemove(ing.id)">
                  <span class="chip-x" *ngIf="packTempRemoved.has(ing.id)">✕</span>
                  {{ ing.name }}
                </button>
              }
            </div>
          </div>
        }

        <!-- Extras -->
        @if (findProductById(packTempItem.product_id)?.ingredients_extras?.length) {
          <div class="add-modal-section">
            <span class="section-label">Extras</span>
            <div class="ingredient-chips">
              @for (extra of findProductById(packTempItem.product_id)!.ingredients_extras!; track extra.id) {
                <button class="ingredient-chip extra" [class.active]="packTempExtras.has(extra.id)" (click)="togglePackExtra(extra.id)">
                  <span class="chip-check" *ngIf="packTempExtras.has(extra.id)">✓</span>
                  {{ extra.name }}
                  <span class="chip-price" *ngIf="extra.extra_price">+{{ extra.extra_price }}€</span>
                </button>
              }
            </div>
          </div>
        }

        <div class="add-modal-actions">
          <button class="add-modal-btn-note" (click)="packGoBack()">Atras</button>
          <button class="add-modal-btn-add" (click)="confirmPackItemCustomization()">Confirmar</button>
        </div>
      </div>
    }

    <!-- Summary step -->
    @if (isPackSummaryStep) {
      <div class="pack-summary">
        <span class="section-label">Tu seleccion</span>
        <div class="pack-summary-list">
          @for (sel of packSelections; track $index) {
            <div class="pack-summary-item">
              <span>{{ sel.item.product_name }}</span>
              <span class="pack-item-supplement" *ngIf="sel.item.supplement_price">+{{ formatPrice(+(sel.item.supplement_price || 0)) }}</span>
            </div>
          }
        </div>
      </div>

      <!-- Note -->
      <div class="add-modal-note" *ngIf="packShowNote">
        <input type="text" [(ngModel)]="packNote" placeholder="Nota especial..." class="add-note-input" maxlength="100" />
      </div>

      <div class="add-modal-actions">
        <button class="add-modal-btn-note" (click)="packShowNote = !packShowNote">{{ packShowNote ? 'Ocultar' : 'Nota' }}</button>
        <button class="add-modal-btn-add" (click)="confirmPack()">Anadir {{ formatPrice(packTotalPrice) }}</button>
      </div>

      <button class="add-modal-btn-note pack-back-btn" (click)="packGoBack()">Atras</button>
    }
  </div>
}